import { isEmpty, isNil } from 'lodash-es';
import type { TreeNode } from './../../../../types/components/tree';
import { Builder } from 'builder-pattern';

export default () => {
  const dataToTreeNode = (obj: any, parentId: string): TreeNode => {
    return Builder<TreeNode>()
      .key(obj.id)
      .data(obj)
      .children(toTreeData(obj.child_nodes, obj.id))
      .parentKey(parentId)
      .styleClass(parentId ? 'c-child-row' : '')
      .build();
  };

  // @ts-expect-error FIXME: Parameter 'parentId' implicitly has 'any' type
  const toTreeData = (array: any[], parentId = null): TreeNode[] => {
    if (isNil(array) || isEmpty(array)) {
      return [];
    } else {
      return array.map((el) => {
        return dataToTreeNode(el, parentId);
      });
    }
  };

  const toSelectedAllKeys = (array: TreeNode[], result = {}): any => {
    if (isNil(array) || isEmpty(array)) {
      return null;
    } else {
      array.forEach((element) => {
        // @ts-expect-error FIXME: Element implicitly has 'any' type
        result[element.data.id] = {
          checked: true,
          partialChecked: false,
        };

        if (element?.children?.length > 0) {
          toSelectedAllKeys(element?.children, result);
        }
      });

      return result;
    }
  };

  const toUnselectedAllKeys = (array: TreeNode[], result = {}): any => {
    if (isNil(array) || isEmpty(array)) {
      return null;
    } else {
      array.forEach((element) => {
        // @ts-expect-error FIXME: Element implicitly has 'any' type
        result[element.data.id] = {
          checked: false,
          partialChecked: false,
        };

        if (element?.children?.length > 0) {
          toUnselectedAllKeys(element?.children, result);
        }
      });

      return result;
    }
  };

  const mapNodesToPartialCheck = (nodes: TreeNode[], initialNode: TreeNode): string[] => {
    const results: string[] = [];

    nodes.forEach((nodeEl) => {
      const parentNode = searchTreeNode(nodeEl, initialNode.parentKey);

      if (parentNode?.children?.length === 1) {
        results.push(parentNode.key);
      }

      if (parentNode?.parentKey) {
        results.push(...mapNodesToPartialCheck(nodes, parentNode));
      }
    });

    return results;
  };

  const searchTreeNode = (element: TreeNode, matchingKey: string): TreeNode | null => {
    if (element.key === matchingKey) {
      return element;
    }

    if (element.children !== null) {
      const result = element.children.find((child) => searchTreeNode(child, matchingKey));
      return result ?? null;
    }

    return null;
  };

  const countNodes = (nodes: TreeNode[]): number => {
    let count = 0;

    if (nodes?.length) {
      nodes.forEach((nodeEl) => {
        count++;
        count += countNodes(nodeEl.children ?? []);
      });
    } else if (nodes?.length === 1) {
      count = 1;
    }

    return count;
  };

  return {
    toTreeData,
    toSelectedAllKeys,
    mapNodesToPartialCheck,
    searchTreeNode,
    toUnselectedAllKeys,
    countNodes,
  };
};
